import { cnUtils } from '@alife/cn-ui';
import * as CnFilterLog from './cn-filter-log';

const { pluginManager } = cnUtils || {};

pluginManager?.registerPlugin?.([
  {
    componentName: 'CnFilterPro',
    docUrl: 'https://cone.cainiao-inc.com/market/awesome?business=internationality&id=3313',
    plugins: [
      {
        name: 'CnFilterLog',
        sourceCode: CnFilterLog.SourceCode,
        // lowCode: CnFilterLog.LowCode,
        // oneCode: CnFilterLog.OneCode,
      },
    ],
  },
]);

if (window?.__self__cn_filter_l2_log) {

  function onEvent(eventName, func){
    const events =  cnUtils?.events;
    if(events && eventName && typeof func === 'function') {
      events?.on(eventName, func)
    }
  }

  onEvent('L2_CnFilter_onSearch', (props) => {
    try {
      const { componentProps, payload } = props
      const { _context, _bindTable } = componentProps 
    
      const api = (_context?.$(_bindTable) || {}).props?.remote?.url
    
      const nameMap = {}
      componentProps?.config.map(i => {
        if (!nameMap[i.name]) nameMap[i.name] = i 
      })
      if (!window.trace) return 
      window.trace.reportFilter({
        // 全量的查询字段配置
        allFields: componentProps?.config || [],
        // 用户查询内容及查询值
        filterFields: Object.keys(payload || {}).map(i => {
          return {
            key: i,
            label: nameMap[i]?.label,
            value: payload[i]
          }
        }),
        // 列表请求接口
        api
      });
    } catch (e) {
      console.error('cnFilterLog log error =>', e)
    }
  })
}
